export default __webpack_public_path__ + "static/media/download_bg.e1a06c25.png";